<template>
    <div :class="['help-mod', ...className]" v-if="show">
        <div class="help-container">
            <h3>{{ $t("dashboard.help") }}</h3>
            <ul class="contact-button">
                <li class="support">
                    <a :href="getOfficialUrl( config.contact_us )" target="_blank">
                        <span class="icon-icon_contact-support help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.cantact") }}</p>
                    </a>
                </li>
                <li class="ask" v-if="!FEATURE('help.community')">
                    <a href="https://reolink.com/forum/" target="_blank">
                        <span class="icon-icon_ask-community help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.ask") }}</p>
                    </a>
                </li>
                <li class="facebook" v-if="!FEATURE('help.facebook')">
                    <a :href="config.facebookUrl" target="_blank">
                        <span class="icon-icon_facebook-2 help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.facebook") }}</p>
                    </a>
                </li>
                <li class="twitter" v-if="!FEATURE('help.twitter')">
                    <a :href="config.twitterUrl" target="_blank">
                        <span class="icon-icon_twitter-2 help-icon"></span>
                        <p class="help-des">{{ $t("dashboard.twitter") }}</p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { config } from 'CONFIG';
export default {

    data () {

        return {

            config

        };

    },

    computed: {

        show () {

            return !this.$route.path.includes( '/checkout/' );

        },
        className () {

            let name = this.$route.name;
            let pcNames = [

                'play',
                'library',
                'cloudPlanPaymentHistory',
                'homepage',
                '404'

            ];
            let mNames = [

                'dashboard',
                'play',
                'library',
                'subscribePlan',
                'cloudPlanPaymentHistory',
                'updatePlan',
                'cancelPlan',
                'cancelPlanComplete',
                'homepage',
                '404',
                'switchSuccess'

            ];
            let className = [];
            if ( pcNames.includes( name )) {

                className.push( 'pc-grey' );

            }
            if ( mNames.includes( name )) {

                className.push( 'm-grey' );

            }
            return className;

        }

    }

};
</script>
<style type="text/css" lang="less" scoped>

    .help-mod {
        background-color: #fff;
        padding: .6rem 0;
        @media @mobile{
            &.m-grey{
                background-color: #f7f8f9;
            }
        }
        @media @pc{
            &.pc-grey{
                background-color: #f7f8f9;
            }
        }
    }

    .help-mod .help-container {
        max-width: 1200px;
        margin: 0 auto;
    }

    .help-mod .help-icon {
        display: inline-block;
        color: #fff;
        font-size: 0.22rem;
        vertical-align: middle;
    }

    .help-mod h3{
        color: #2b2b2b;
        font-weight: 500;
        font-size: .28rem;
        text-align: center;
        margin-bottom: .4rem;
    }
    .contact-button{
        max-width: 9.8rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 0 auto;
    }
    .contact-button li{
        display: inline-block;
        height: .6rem;
        width: 2.35rem;
        border-radius: .1rem;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        top: 0;
        transition: top .5s;
        -moz-transition: top .5s;
        -webkit-transition: top .5s;
        -o-transition: top .5s;
        -ms-transition: top .5s;
    }
    .contact-button li a{
        display:flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 .26rem 0 0.2rem;
        height: 100%;
        box-sizing: border-box;
    }
    .contact-button li:hover{
        top: -6px;
        -o-box-shadow: 0px 7px 8px rgba(56, 154, 255, 0.2);
        -moz-box-shadow: 0px 7px 8px rgba(56, 154, 255, 0.2);
        -webkit-box-shadow: 0px 7px 8px rgba(56, 154, 255, 0.2);
        -ms-box-shadow: 0px 7px 8px rgba(56, 154, 255, 0.2);
        box-shadow: 0px 7px 8px rgba(56, 154, 255, 0.2);
    }
    .contact-button li .help-des {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        font-size: .18rem;
        color: #fff;
        width: 100%;
    }

    .contact-button li.facebook .help-des,
    .contact-button li.twitter .help-des {
        width: 100%;
    }

    .contact-button li.support{
        background: @theme-linear-gradient;
    }
    .contact-button li.ask{
        background: @theme-linear-gradient;
    }
    .contact-button li.facebook{
        background-color: #3f5d8b;
    }

    .contact-button li.twitter{
        background-color: #44a8e6;
    }

    @media screen and (max-width:1199px) {

        .help-mod {
            background-color: #f3f4f9;
        }

        .help-mod h3 {
            margin-bottom: 0.6rem;
            font-size: 0.36rem;
        }

        .contact-button li .help-des {
            font-size: 0.24rem;
        }

        .help-mod .help-icon {
            font-size: 0.32rem;
        }

        .contact-button {
            display: block;
            text-align: center;
            max-width: 650px;
        }

        .contact-button li {
            width: 2.7rem;
            height: 0.78rem;
        }

        .contact-button li:nth-child(2n+2) {
            margin-left: 0.3rem;
        }

        .contact-button li.facebook,
        .contact-button li.twitter {
            margin-top: 0.3rem;
        }

    }

    @media screen and (max-width:800px) {

        .contact-button {
            display: block;
            text-align: center;
            padding: 0 0.5rem;
        }

    }

    @media screen and (max-width:375px) {
         .contact-button {
            padding: 0 0.2rem;
         }
         .contact-button li {
             width: 3rem;
         }
         .contact-button li a {
             padding: 0 0.26rem;
         }
         .help-mod .help-icon {
             font-size: 0.36rem;
         }
         .contact-button li .help-des {
             font-size: 0.26rem;
         }

    }

    @media screen and (max-width:320px) {
  
         .contact-button li {
             width: 3.3rem;
         }

    }

</style>



// WEBPACK FOOTER //
// src/components/needHelp.vue